import { useState } from "react";
import { useCart } from "../../contextApi/cartContext";
import DatePicker from "react-datepicker";
import { BsCalendar2 } from "react-icons/bs";
import tabby from "../../../assets/tabbytamara.png";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import axios from "axios";
import API_URL from "../../../config";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { cartItems, removeFromCart } = useCart();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    address: "",
    appointmentDate: null,
  });

  console.log("Cart items", cartItems);

  const totalPrice = cartItems.reduce((sum, item) => sum + item.price, 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log("Form Submitted:", formData);
    // const date = formData.appointmentDate;
    // const formattedDate = date
    //   ? `${String(date.getDate()).padStart(2, "0")}/${String(
    //       date.getMonth() + 1
    //     ).padStart(2, "0")}/${date.getFullYear()} ${
    //       date.getHours() % 12 || 12
    //     }:${String(date.getMinutes()).padStart(2, "0")} ${
    //       date.getHours() >= 12 ? "PM" : "AM"
    //     }`
    //   : "";

    const serviceNames = cartItems.map((item) => item.title);
    const payload = {
      ...formData,
      bookedServices: serviceNames,
      // appointmentDate: formattedDate,
      totalPrice: totalPrice,
    };

    console.log("Payload in multi form", payload);
    try {
      const res = await axios.post(`${API_URL}/layout/send-mail`, payload);
      if (res.data.success) {
        toast.success("Thanks for connecting with us");
        setFormData({
          firstName: "",
          email: "",
          phone: "",
          address: "",
          appointmentDate: null,
          // include any other fields your formData initially had
        });
        navigate("/home");
      } else {
        toast.error("Something went wrong: " + res.data.error);
      }
    } catch (error) {
      toast.error("❌ Failed to submit. Please try again.");
    }
  };

  return (
    <div
      className="my-5 mx-auto"
      style={{
        maxWidth: "1200px",
      }}
    >
      <h3 className="text-center fw-bold mb-4" style={{ color: "#c69933" }}>
        🩺 Your Selected Treatments & Booking Info
      </h3>

      {cartItems.length === 0 ? (
        <div className="text-center text-muted">
          You haven't selected any treatments yet.
        </div>
      ) : (
        <div className="row">
          {/* Cart Treatments */}
          {/* Cart Treatments */}
          <div className="col-md-7">
            <div className="border-0 shadow-sm p-4 rounded-4 mb-4">
              <h5 className="fw-bold mb-3" style={{ color: "#c69933" }}>
                Selected Services
              </h5>

              {cartItems.map((item, index) => (
                <div key={index} className="border-bottom py-3">
                  {/* Top Row: Image + AED/Remove */}
                  <div className="d-flex  justify-content-between">
                    {/* Left: Image */}
                    <img
                      src={item.image}
                      alt={item.title}
                      className="rounded-3"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />

                    {/* Right: AED + Remove Button stacked */}
                    <div className="d-flex  flex-column ">
                      <span className="fw-bold text-success mb-3">
                        AED {item.price}
                      </span>
                      <button
                        className=" rounded-pill px-3 mt-2"
                        style={{
                          color: "#dc3545",
                          border: "1px solid #dc3545",
                          backgroundColor: "transparent",
                        }}
                        onClick={() => removeFromCart(item?.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>

                  {/* Bottom: Title + Description full width */}
                  <div className="mt-3 ps-1 ps-md-0">
                    <h6 className="mb-1 fw-semibold">{item.title}</h6>
                    <p className="text-muted small mb-0">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Checkout Form */}
          <div className="col-md-5">
            <div className="border-0 shadow-sm p-4 rounded-4">
              <h5 className="fw-bold text-center" style={{ color: "#c69933" }}>
                Treatment Booking Details
              </h5>
              <small className="text-muted text-center d-block mb-3">
                Let us know your details to personalize your experience
              </small>

              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  className="form-control custom-input"
                  required
                  placeholder="Enter FullName"
                  value={formData.firstName}
                  onChange={(e) =>
                    setFormData({ ...formData, firstName: e.target.value })
                  }
                />

                <input
                  type="email"
                  className="form-control custom-input my-2"
                  required
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />

                <div className="mb-2">
                  <PhoneInput
                    country={"ae"}
                    enableSearch
                    value={formData.phone}
                    onChange={(phone) => setFormData({ ...formData, phone })}
                    inputStyle={{
                      width: "100%",
                      height: "50px",
                      paddingLeft: "60px",
                      borderRadius: "0.375rem",
                      border: "1px solid #c69933",
                    }}
                  />
                </div>

                <input
                  type="text"
                  className="form-control custom-input my-2"
                  required
                  placeholder="Enter Address"
                  value={formData.address}
                  onChange={(e) =>
                    setFormData({ ...formData, address: e.target.value })
                  }
                />

                <div className="mb-3">
                  <div className="position-relative w-100">
                    <BsCalendar2 className="calendar-icon" />
                    <DatePicker
                      selected={formData.appointmentDate}
                      onChange={(date) =>
                        setFormData({ ...formData, appointmentDate: date })
                      }
                      minDate={new Date()}
                      placeholderText="Preferred Appointment Date & Time"
                      className="form-control w-100 ps-5"
                      wrapperClassName="w-100"
                      showTimeSelect
                      dateFormat="Pp"
                    />
                  </div>
                </div>

                <hr />

                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-semibold">Treatment Total:</span>
                  <span className="text-success">AED {totalPrice}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-semibold">Consultation Fee:</span>
                  <span className="text-muted">AED 0</span>
                </div>

                <hr />

                <div className="d-flex justify-content-between fw-bold mb-4">
                  <span>Total Amount:</span>
                  <span style={{ color: "#c69933" }}>AED {totalPrice}</span>
                </div>

                {/* <button
                  className=" w-100 py-2 rounded text-white mb-3"
                  style={{
                    backgroundColor: "#c69933",
                    outline: "none",
                    boxShadow: "none",
                  }}
                >
                  Confirm Appointment
                </button> */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className=" w-100 py-2 rounded text-white mb-3"
                  style={{
                    backgroundColor: isSubmitting ? "#ccc" : "#bdaa7d",
                    border: "2px solid #c69933",

                    cursor: isSubmitting ? "not-allowed" : "pointer",
                  }}
                >
                  {isSubmitting ? "Submitting..." : " Confirm Appointment "}
                </button>
              </form>

              {/* Clean tabby image at the bottom of the card */}
              <div className="text-center">
                <img
                  src={tabby}
                  alt="Tabby Payment Option"
                  style={{
                    maxWidth: "180px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <style>{`
    .calendar-icon {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      color: #c69933;
      font-size: 1.2rem;
      z-index: 2;
      pointer-events: none;
    }

    .datepicker-input {
      height: 45px;
      font-size: 1rem;
      border: 1px solid #c69933;
      border-radius: 0.375rem;
      white-space: nowrap; /* Prevents wrapping */
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media (max-width: 576px) {
      .datepicker-input {
        font-size: 0.9rem;
        padding-left: 2.2rem;
        height: 42px;
      }

      .calendar-icon {
        font-size: 1rem;
        left: 10px;
      }
    }
  `}</style>
    </div>
  );
};

export default Cart;
